import { render } from "./auditor.vue?vue&type=template&id=51997728&ts=true"
import script from "./auditor.ts?vue&type=script&lang=ts&external"
export * from "./auditor.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__